import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import { Grid, GridItem } from "components/Grid"
import { Flex, FlexItem } from "components/Flex"

import pictogramArticle from "assets/img/pictogram/article.svg"

import Pictogram from "components/Pictogram/Pictogram"
import Button from "components/Button/Button"
import Lmid from "components/Lmid/Lmid"
import { IInvoiceDetailsAssignedAsset } from "models/InvoiceDetails"
import articleSidebars from "stores/articleSidebars"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import Text from "components/Text/Text"

interface IInvoiceSidebarAssetProps {
    asset: IInvoiceDetailsAssignedAsset
}

const InvoiceSidebarAsset: FunctionComponent<React.PropsWithChildren<IInvoiceSidebarAssetProps>> = ({
    asset,
}) => {
    const { t } = useTranslation()

    function showArticleDetails() {
        articleSidebars.show({ articleId: asset.articleId })
    }

    return (
        <Grid
            columns="6.4rem minmax(0, 100%)"
            gap="2.4rem"
            data-testid="invoice-sidebar-asset">
            <GridItem>
                <Pictogram src={pictogramArticle} />
            </GridItem>
            <GridItem alignSelf="center">
                <Button
                    theme="link"
                    className="mb-1"
                    label={asset.articleDescription}
                    onClick={showArticleDetails}
                    userSelect="text"
                    clamp={1}
                />
                <Flex justifyContent="space-between">
                    <FlexItem>
                        <Grid columns="max-content minmax(0, max-content)" gap="0.8rem">
                            <GridItem>{t('common.lmid')}:</GridItem>
                            <GridItem>
                                <Lmid
                                    lmid={asset.lmid}
                                    assetId={asset.id}
                                    labeled={asset.isAssetLabeled}
                                    assetVersion={asset.version}
                                    assetVersioned={asset.version > 1}
                                />
                            </GridItem>
                        </Grid>
                    </FlexItem>
                    <FlexItem shrink={0} className="text-right ml-3">
                        {}
                        <Flex flow="column" alignItems="flex-end">
                            <FlexibleContent text={asset.assignedAmount.print()} />
                            {asset.assignedForeignCurrencyAmount && <Text type="pSmallest" className="color-grey-500" >
                                {asset.assignedForeignCurrencyAmount.print()}
                            </Text>}
                        </Flex>,
                    </FlexItem>
                </Flex>
            </GridItem>
        </Grid>
    )
}

export default InvoiceSidebarAsset
